import React from 'react'

import Category from './Category'
import FlexGrid from '../../../../components/structure/FlexGrid'

const CategoriesList = ({ categories, hideCategories }) => {
  if (!categories || !categories.length) return false

  return (
    <FlexGrid direction="column" align="stretch">
      {categories.map(category => (
        <Category key={category.id} item={category} hideCategories={hideCategories} />
      ))}
    </FlexGrid>
  )
}

export default CategoriesList
